import { inject, provide } from 'vue';

import type { NTable } from '../interface';
import type { IFixedInfo } from '../utils';
import type { InjectionKey } from 'vue';

export interface ITableContextProps {
  getComponent: NTable.NCustomize.TGetComponent;
  scrollbarSize: number;
  fixedInfoList: readonly IFixedInfo[];
  isSticky: boolean;
  summaryCollect: (uniKey: string, fixed: boolean | string) => void;
  transformCellText?: NTable.NCell.TTransformCellText<unknown>;
}

export const TableContextKey: InjectionKey<ITableContextProps> = Symbol('cds:table');

export const useProvideTable = (props: ITableContextProps) => {
  provide(TableContextKey, props);
};

export const useInjectTable = () => {
  return inject(TableContextKey, {} as ITableContextProps);
};

type TContextProps = {
  onResizeColumn: (width: number, column: NTable.NColumn.IColumn) => void;
};

const ContextKey: InjectionKey<TContextProps> = Symbol('cds:table:context');
export const useProvideTableContext = (props: TContextProps) => {
  provide(ContextKey, props);
};

export const useInjectTableContext = () => inject(ContextKey, { onResizeColumn: () => {} } as TContextProps);
